export default __webpack_public_path__ + "static/media/icon-high-quality.456fd2f3.svg";